class ProductDonation {
  constructor() {
    this.form = document.querySelector('[data-donation-form]');
    this.toggle = document.querySelector('[data-donation-form-toggle]');
    this.options = document.querySelector('[data-donation-form-options]');
    this.optionInputs = document.querySelectorAll('[data-donation-form-input]');
    this.productForm = document.querySelector('[data-type="add-to-cart-form"]');
    this.boundHandleToggle = this.handleToggle.bind(this);
    this.boundHandleOptionChange = this.handleOptionChange.bind(this);
    this.init();
  }

  // set up event listeners
  /**
   * @method init
   * @private
   */
  init() {
    this.toggle.addEventListener('change', this.boundHandleToggle);
    this.optionInputs.forEach((option) => {
      option.addEventListener('change', this.boundHandleOptionChange);
    });
  }

  /**
   * @method handleToggle
   * @private
   */
  handleToggle() {
    const isChecked = this.toggle.checked;
    this.options.setAttribute('aria-hidden', !isChecked);
    this.options.style.maxHeight = isChecked ? `${this.options.scrollHeight}px` : '0px';
    if (isChecked) {
      const variantId = this.getSelectedVariantId();
      this.addDonationToForm(variantId);
    } else {
      this.removeDonationFromForm();
    }
  }

  /**
   * @method handleOptionChange
   * @private
   * @param {Event} event - The change event
   */
  handleOptionChange(event) {
    const selectedOption = event.target;
    const variantId = selectedOption.dataset.variantId;

    if (this.toggle.checked) {
      this.updateDonationInForm(variantId);
    }
  }

  /**
   * @method getSelectedVariantId
   * @private
   * @returns {string} The currently selected variant ID
   */
  getSelectedVariantId() {
    const checkedOption = Array.from(this.optionInputs).find((input) => input.checked);
    return checkedOption ? checkedOption.dataset.variantId : this.optionInputs[0].dataset.variantId;
  }

  /**
   * @method addDonationToForm
   * @private
   * @param {string} variantId - The variant ID to add
   */
  addDonationToForm(variantId) {
    const quantityInput = document.createElement('input');
    quantityInput.type = 'hidden';
    quantityInput.name = 'items[1][quantity]';
    quantityInput.value = '1';
    quantityInput.dataset.donationField = 'quantity';

    const idInput = document.createElement('input');
    idInput.type = 'hidden';
    idInput.name = 'items[1][id]';
    idInput.value = variantId;
    idInput.dataset.donationField = 'id';

    this.productForm.appendChild(quantityInput);
    this.productForm.appendChild(idInput);
  }

  /**
   * @method updateDonationInForm
   * @private
   * @param {string} variantId - The new variant ID
   */
  updateDonationInForm(variantId) {
    const idInput = this.productForm.querySelector('[data-donation-field="id"]');
    if (idInput) {
      idInput.value = variantId;
    }
  }

  /**
   * @method removeDonationFromForm
   * @private
   */
  removeDonationFromForm() {
    const donationFields = this.productForm.querySelectorAll('[data-donation-field]');
    donationFields.forEach((field) => field.remove());
  }
}

// add variant id to form data when checkbox is toggled

// change id in form data when variant changes

// remove variant id from form data when checkbox is toggled off

customElements.define(
  'product-donation',
  class ProductDonationElement extends HTMLElement {
    constructor() {
      super();
      this.donation = null;
    }

    connectedCallback() {
      this.donation = new ProductDonation();
    }
  }
);
